// Guards compartidos por los trackers de terceros (Clarity, GA4).
// Un solo lugar para decidir cuándo NO ensuciar los dashboards.

/**
 * Decide si un tracker de terceros debe cargar. Guard doble:
 * 1. En localhost solo con build de producción — npm start y los e2e de
 *    Playwright (dev server) no mandan datos, pero se puede verificar la
 *    instalación sirviendo un build local.
 * 2. Nunca en navegadores automatizados (e2e contra builds de prod, probes,
 *    prerenders): navigator.webdriver.
 */
export function shouldLoadTracker(hostname: string, isProdBuild: boolean, isAutomated: boolean): boolean {
  const isLocalhost = ['localhost', '127.0.0.1'].includes(hostname);
  return (!isLocalhost || isProdBuild) && !isAutomated;
}
